import { gql } from '@apollo/client';

import { processResponse } from './helper';

export const getNotificationsQuery = gql`
  query getNotifications(
    $startTime: Float
    $endTime : Float
    $nextToken : String
  ) {
    getNotifications(
      startTime: $startTime
      endTime: $endTime
      nextToken: $nextToken
    ) {
        notificationList {
          notificationId
          userId
          rfxRevisionedIdentifier {
            id {
                value
            }
            revision
          }
          createdAt
          updatedAt
          notificationText
          notificationCategory
          messageState
          ttl
        }
        nextToken
      }
    }
`;

export default function getNotifications(this: any, request: any) {
  return processResponse(
    this.query({
      query: getNotificationsQuery,
      variables: request,
      fetchPolicy: 'network-only'
    }),
    'getNotifications'
  );
}
